import React from 'react';
import PageWrapper from '../../components/PageWrapper';
import MiniPersonCard from './MiniPersonCards';
import { useContactsList } from './../../queries/contact';
import { useContactusPageHeader } from './../../queries/contactusPageHeader';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import Footer from './../../components/Footer/index';
import MiniPersonCard2 from './MiniPersonCard2';
import ToolBarMenu from './../../components/ToolBarMenu/index';
import InfinitProgressBar from '../../components/InfiniteProgressBar';



const ContactUS = () => {

    const {data, error, loading} = useContactsList();
    const contactusPage = useContactusPageHeader();
    if (error) return <div>error!</div>
    if (loading) return <InfinitProgressBar />

    if (contactusPage.error) return <div>error!</div>
    if (contactusPage.loading) return <InfinitProgressBar />

   
    
    // var groupBy = function(xs, key) {
    //     return xs.reduce(function(rv, x) {
    //       (rv[x[key]] = rv[x[key]] || []).push(x);
    //       return rv;
    //     }, {});
    //   };
      if (!data) {
        return;
      }
  

      const level1 = data.contact.filter(i=> parseInt(i.level) === 1)
      const level2 = data.contact.filter(i=> parseInt(i.level) === 2)
      const level3 = data.contact.filter(i=> parseInt(i.level) === 3)
      const level4 = data.contact.filter(i=> parseInt(i.level) === 4)



    return (  
        <PageWrapper>
            <div className="col-12">
                {/* <ToolBarMenu/> */}
                <Header/>
                <PageHeader
                    // bgImg={require('../../assets/img/page-header.jpg')}
                    // title={'تماس با ما'}
                    // content={''}
                    bgImg={contactusPage.data.contactusPageHeader[0].contactusPageHeaderImage.urls[0]}
                    title={contactusPage.data.contactusPageHeader[0].displayText}
                    content={contactusPage.data.contactusPageHeader[0].contactusPageHeaderSubtitle.html}
                />
                <MiniPersonCard level1={level1}  level2={level2} level3={level3} level4={level4} />
                {/* <MiniPersonCard2 level1={level1}  level2={level2} level3={level3} level4={level4} /> */}
                <br/>
                <br/>
                <br/>
                <Footer/>
            </div>
        </PageWrapper>
    );
}
 
export default ContactUS;